import { getFullName } from '../../util';

export const selectParticipant = ({ participant }) => {
  if (!participant.size) {
    return undefined;
  }
  const person = participant.toJS();

  return {
    ...person,
    fullName: getFullName(person),
  };
};
